import { tryParseInt } from '@witkac/utils/tryParseInt';
import { Route } from 'vue-router';

import { Storage } from '@/enums/storage.enum';
import store from '@/store/store';
import { parseJsonOrDefault } from './parseJsonOrDefault';
import { prepareQuery } from './prepareQuery';
import { removeEmptyObjectFields } from './removeEmptyFields';

/**
 * Pobiera raport decyzji
 *
 * @export
 * @param {Route} route
 * @returns {Promise<any>}
 */
export function getDecisionReport(route: Route): Promise<any> {
  const filtersJson = sessionStorage.getItem(Storage.REPORT_DECISION_FILTERS);
  const filters = removeEmptyObjectFields(parseJsonOrDefault(filtersJson, {}));
  return store.dispatch('statistics/getAttachmentStatistics', {
    procedureId: tryParseInt(route.params.procedureId),
    filters: { ...prepareQuery(route), count: -1, filterFields: filters }
  });
}
